webpackJsonp([82263325369400],{

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '/config/auth.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is the configuration file for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-auth'
	      ),
	      ' and is where you define overrides for the default authentication behaviors.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'New projects include a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser'
	      ),
	      ' model, and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-auth'
	      ),
	      ' hook will generate an action called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser'
	      ),
	      ' that will fetch the user, and a reducer called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser'
	      ),
	      ' that will store the result of that action.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file let\'s you control the name of the model, action and reducer used for fetching and storing the current user.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can learn more about the configuration options ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/hooks/lore-hook-auth/' },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Default Config'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default config is shown below.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      /**\n       * Configuration file for authentication\n       *\n       * This file is where you define overrides for the default authentication behaviors.\n       */\n\n      export default {\n\n        /**\n         * The name of the model with a URL property set to the endpoint\n         * that can return the current user.\n         */\n\n        modelName: \'currentUser\'\n\n        /**\n         * The name of the reducer that should be created that is responsible\n         * for storing the current user. This defaults to the name of the\n         * model.\n         */\n\n        reducerName: \'currentUser\'\n\n        /**\n         * The name of the action that should be created at this responsible\n         * for fetching the current user. This defaults to the name of the\n         * model.\n         */\n\n        actionName: \'currentUser\'\n\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-config-auth-js-d07a3e4d3ac96f897b31.js